(() => {
  if (window.PeecesWishlist) return;
  const configNode = document.getElementById('pcs-wishlist-config');
  const dialog = document.getElementById('pcs-wishlist');
  if (!configNode || !dialog) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const labels = config.labels;
  const storageKey = `peeces:wishlist:v1:${config.shop}`;
  const root = `${config.root.replace(/\/$/, '')}/`;
  const grid = dialog.querySelector('[data-wishlist-grid]');
  const status = dialog.querySelector('[data-wishlist-status]');
  const empty = dialog.querySelector('[data-wishlist-empty]');
  const retry = dialog.querySelector('[data-wishlist-retry]');
  const heart = document.getElementById('pcs-wishlist-heart');
  const toast = document.querySelector('[data-wishlist-toast]');
  const listeners = new Set();
  const details = new Map();
  const requests = new Map();
  const busy = new Set();
  let state = { version: 1, items: [], removed: [] };
  let storageAvailable = true;
  let opener = null;
  let toastTimer;
  let renderVersion = 0;
  const clone = value => JSON.parse(JSON.stringify(value));
  const text = value => typeof value === 'string' ? value.slice(0, 500) : '';
  const productId = value => String(value || '').replace(/^gid:\/\/shopify\/Product\//, '').match(/^\d+$/)?.[0] || '';
  const safeImage = value => {
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com') ? url.href : ''; } catch { return ''; }
  };
  const normalize = value => {
    if (!value || typeof value !== 'object') return null;
    const handle = text(value.handle);
    if (!/^[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(handle)) return null;
    return { id: productId(value.id), handle, title: text(value.title) || handle, vendor: text(value.vendor), image: safeImage(value.image), addedAt: Number(value.addedAt) || Date.now(), updatedAt: Number(value.updatedAt) || Date.now() };
  };
  function readStorage() {
    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return { version: 1, items: [], removed: [] };
      const data = JSON.parse(raw);
      if (data.version !== 1 || !Array.isArray(data.items)) return state;
      const seen = new Set();
      const items = data.items.slice(0, 500).map(normalize).filter(item => {
        if (!item || seen.has(item.handle)) return false;
        seen.add(item.handle);
        return true;
      });
      return { version: 1, items, removed: Array.isArray(data.removed) ? data.removed.slice(-500) : [] };
    } catch { storageAvailable = false; return state; }
  }
  state = readStorage();
  const sameProduct = (a, b) => a.handle === b.handle || Boolean(a.id && b.id && a.id === b.id);
  const findItem = value => state.items.find(item => sameProduct(item, value));
  function announce(message) {
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, storageAvailable ? 3200 : 6500);
  }
  function notify() {
    syncButtons();
    listeners.forEach(listener => { try { listener(clone(state.items)); } catch {} });
    document.dispatchEvent(new CustomEvent('pcs:wishlist-changed', { detail: { count: state.items.length } }));
  }
  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify(state)); storageAvailable = true; }
    catch { storageAvailable = false; }
    notify();
  }
  function buttonData(button) {
    return normalize({ id: button.dataset.wishlistId, handle: button.dataset.wishlistHandle, title: button.dataset.wishlistTitle, vendor: button.dataset.wishlistVendor, image: button.dataset.wishlistImage });
  }
  function syncButton(button) {
    const item = buttonData(button);
    if (!item) return;
    const saved = Boolean(findItem(item));
    button.hidden = false;
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? labels.remove : labels.save}: ${item.title}`);
    button.title = saved ? labels.remove : labels.save;
    const label = button.querySelector('[data-wishlist-label]');
    if (label) label.textContent = saved ? labels.saved : labels.save;
  }
  function syncButtons() {
    document.querySelectorAll('[data-pcs-wishlist-toggle]').forEach(syncButton);
    document.querySelectorAll('[data-pcs-wishlist-open]').forEach(link => {
      link.hidden = false;
      link.setAttribute('aria-label', `${labels.title} (${state.items.length})`);
      const badge = link.querySelector('[data-wishlist-count]');
      if (badge) { badge.textContent = String(state.items.length); badge.hidden = state.items.length === 0; }
    });
    dialog.querySelector('[data-wishlist-total]').textContent = state.items.length ? `(${state.items.length})` : '';
  }
  function createButton(item) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pcs-wishlist-toggle pcs-wishlist-toggle--card';
    button.dataset.pcsWishlistToggle = '';
    button.dataset.wishlistId = item.id || '';
    button.dataset.wishlistHandle = item.handle;
    button.dataset.wishlistTitle = item.title;
    button.dataset.wishlistVendor = item.vendor || '';
    button.dataset.wishlistImage = item.image || '';
    button.append(heart.content.cloneNode(true));
    syncButton(button);
    return button;
  }
  function enhance(scope = document) {
    const cards = [...scope.querySelectorAll('product-block')];
    if (scope.matches?.('product-block')) cards.unshift(scope);
    cards.forEach(card => {
      if (card.querySelector('[data-pcs-wishlist-toggle]')) return;
      const link = card.querySelector('a.product-link[href*="/products/"]');
      const host = card.querySelector('.image-cont');
      if (!link || !host) return;
      let handle;
      try { handle = new URL(link.href).pathname.match(/\/products\/([^/]+)/)?.[1]; } catch { return; }
      const item = normalize({ id: card.dataset.productId, handle, title: card.querySelector('.product-block__title')?.textContent.trim(), vendor: card.querySelector('.vendor')?.textContent.trim(), image: host.querySelector('img')?.currentSrc || host.querySelector('img')?.src });
      if (!item) return;
      host.classList.add('pcs-wishlist-card-host');
      host.append(createButton(item));
    });
    scope.querySelectorAll('[data-pcs-wishlist-toggle]').forEach(syncButton);
    if (scope.matches?.('[data-pcs-wishlist-toggle]')) syncButton(scope);
    scope.querySelectorAll('[data-pcs-wishlist-open]').forEach(link => { link.hidden = false; });
  }
  async function fetchProduct(item, fresh = false) {
    if (!fresh && details.has(item.handle)) return details.get(item.handle);
    if (requests.has(item.handle)) return requests.get(item.handle);
    const request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}.js`, { headers: { Accept: 'application/json' }, signal: controller.signal, cache: 'no-store' });
        if (response.status === 404 || response.status === 410) {
          const missing = { missing: true };
          details.set(item.handle, missing);
          return missing;
        }
        if (!response.ok) throw new Error('Product request failed');
        const product = await response.json();
        if (!productId(product.id) || !Array.isArray(product.variants)) throw new Error('Invalid product response');
        const result = { product };
        details.set(item.handle, result);
        return result;
      } finally { clearTimeout(timeout); requests.delete(item.handle); }
    })();
    requests.set(item.handle, request);
    return request;
  }
  async function toggle(button) {
    let item = buttonData(button);
    if (!item || busy.has(item.handle)) return;
    if (storageAvailable) state = readStorage();
    const existing = findItem(item);
    if (existing) {
      state.items = state.items.filter(entry => !sameProduct(entry, existing));
      state.removed.push({ id: existing.id, handle: existing.handle, removedAt: Date.now() });
      state.removed = state.removed.slice(-500);
      persist();
      announce(storageAvailable ? labels.removed : labels.storage_error);
      if (dialog.open) renderList();
      return;
    }
    if (state.items.length >= 500) { announce(labels.limit); return; }
    busy.add(item.handle);
    button.disabled = true;
    try {
      if (!item.id) {
        try {
          const result = await fetchProduct(item);
          if (result.product) item = normalize({ ...item, id: result.product.id, title: result.product.title, vendor: result.product.vendor, image: result.product.featured_image || item.image });
        } catch {}
      }
      if (storageAvailable) state = readStorage();
      if (!findItem(item)) state.items.unshift(item);
      state.removed = state.removed.filter(entry => !sameProduct(entry, item));
      persist();
      announce(storageAvailable ? labels.added : labels.storage_error);
    } finally { button.disabled = false; busy.delete(item.handle); }
  }
  const make = (tag, className, content) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (content !== undefined) element.textContent = content;
    return element;
  };
  const productUrl = item => `${root}products/${encodeURIComponent(item.handle)}`;
  const price = cents => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(cents / 100);
  function renderCard(item, result) {
    const card = make('article', 'pcs-wishlist-card');
    card.dataset.wishlistCard = item.handle;
    const product = result?.product;
    const unavailable = result?.missing || (product && !product.available);
    card.dataset.unavailable = String(Boolean(unavailable));
    const media = make('div', 'pcs-wishlist-card__media');
    const imageLink = make('a');
    imageLink.href = productUrl(item);
    imageLink.tabIndex = -1;
    imageLink.setAttribute('aria-hidden', 'true');
    const imageUrl = safeImage(product?.featured_image || item.image);
    if (imageUrl) {
      const image = make('img');
      const url = new URL(imageUrl);
      url.searchParams.set('width', '600');
      image.src = url.href;
      image.alt = '';
      image.width = 400;
      image.height = 500;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageLink.append(image);
    }
    media.append(imageLink, createButton(item));
    card.append(media);
    card.append(make('span', 'pcs-wishlist-card__vendor', product?.vendor || item.vendor));
    const title = make('a', 'pcs-wishlist-card__title', product?.title || item.title);
    title.href = productUrl(item);
    card.append(title);
    if (product) {
      const pricing = make('div', 'pcs-wishlist-card__price', price(product.price));
      if (product.compare_at_price > product.price) pricing.append(make('del', '', price(product.compare_at_price)));
      card.append(pricing);
    }
    const message = result?.missing ? labels.unavailable : product ? (product.available ? '' : labels.sold) : result?.error ? labels.load_error : labels.loading;
    if (message) card.append(make('div', 'pcs-wishlist-card__state', message));
    return card;
  }
  function updateCard(item, result) {
    const old = [...grid.children].find(card => card.dataset.wishlistCard === item.handle);
    if (!old || !findItem(item)) return;
    const focusInside = old.contains(document.activeElement);
    const card = renderCard(item, result);
    old.replaceWith(card);
    if (focusInside) card.querySelector('button').focus({ preventScroll: true });
  }
  async function renderList() {
    const generation = ++renderVersion;
    const hadFocus = grid.contains(document.activeElement);
    const scrollTop = dialog.querySelector('.pcs-wishlist__body').scrollTop;
    const items = clone(state.items);
    const results = new Map();
    empty.hidden = items.length > 0;
    retry.hidden = true;
    status.textContent = storageAvailable ? '' : labels.storage_error;
    grid.replaceChildren(...items.map(item => renderCard(item)));
    syncButtons();
    if (hadFocus) dialog.querySelector('#pcs-wishlist-title').focus({ preventScroll: true });
    dialog.querySelector('.pcs-wishlist__body').scrollTop = scrollTop;
    let next = 0;
    let errors = false;
    const worker = async () => {
      while (next < items.length && generation === renderVersion && dialog.open) {
        const item = items[next++];
        let result;
        try { result = await fetchProduct(item, true); } catch { result = { error: true }; errors = true; }
        if (generation !== renderVersion || !dialog.open) return;
        results.set(item.handle, result);
        if (result.product) {
          const saved = findItem(item);
          if (saved) Object.assign(saved, { id: productId(result.product.id), title: result.product.title, vendor: result.product.vendor, image: safeImage(result.product.featured_image || saved.image) });
        }
        updateCard(item, result);
      }
    };
    await Promise.all(Array.from({ length: Math.min(4, items.length) }, worker));
    if (generation !== renderVersion || !dialog.open) return;
    [...grid.children].sort((a, b) => Number(a.dataset.unavailable === 'true') - Number(b.dataset.unavailable === 'true')).forEach(card => grid.append(card));
    retry.hidden = !errors;
    status.textContent = !storageAvailable ? labels.storage_error : errors ? labels.load_error : '';
  }
  function open(trigger) {
    if (dialog.open) return;
    if (storageAvailable) state = readStorage();
    opener = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('pcs-wishlist-open');
    dialog.querySelector('[data-wishlist-close]').focus();
    renderList();
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-pcs-wishlist-toggle]');
    if (button) { event.preventDefault(); event.stopPropagation(); toggle(button); return; }
    const trigger = event.target.closest('[data-pcs-wishlist-open]');
    if (trigger) { event.preventDefault(); open(trigger); }
  }, true);
  dialog.querySelector('[data-wishlist-close]').addEventListener('click', () => dialog.close());
  retry.addEventListener('click', renderList);
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    ++renderVersion;
    document.documentElement.classList.remove('pcs-wishlist-open');
    opener?.isConnected && opener.focus({ preventScroll: true });
  });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    state = readStorage();
    notify();
    if (dialog.open) renderList();
  });
  const observer = new MutationObserver(records => {
    const scopes = new Set();
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1 || dialog.contains(node)) return;
      if (node.matches('product-block, [data-pcs-wishlist-toggle], [data-pcs-wishlist-open]') || node.querySelector('product-block, [data-pcs-wishlist-toggle], [data-pcs-wishlist-open]')) scopes.add(node);
    }));
    scopes.forEach(enhance);
    if (scopes.size) syncButtons();
  });
  window.PeecesWishlist = Object.freeze({
    version: 1,
    list: () => clone(state.items),
    exportSnapshot: () => clone(state),
    subscribe: listener => { listeners.add(listener); return () => listeners.delete(listener); },
    enhance,
    open
  });
  enhance();
  syncButtons();
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => { enhance(event.target); syncButtons(); });
  if (location.hash === '#favoriten') open();
})();
